/* 🤖 this file was generated by svg-to-ts */
export const mgcIconRightSmallFilled: {
  name: 'right-small-filled';
  data: string;
} = {
  name: 'right-small-filled',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.8 8.197c-.29.059-.539.252-.69.535l-.09.168v6.2l.09.168c.109.205.257.35.47.461.226.117.618.114.86-.007.124-.062.65-.561 1.686-1.596 1.035-1.036 1.534-1.562 1.596-1.686a1.087 1.087 0 0 0 0-.88c-.118-.237-3.031-3.157-3.262-3.271a1.144 1.144 0 0 0-.66-.092"/></svg>`
};
